import React from 'react';
import { LifeBuoy } from 'lucide-react';
import { ActiveStarter } from '../components/home/ActiveStarter';
import { ActiveBakes } from '../components/home/ActiveBakes';
import { RecentResults } from '../components/home/RecentResults';
import { BakingSession, Starter } from '../types/baking';
import { User } from 'firebase/auth';

interface HomeProps {
  bakingSessions: BakingSession[];
  starters: Starter[];
  onSessionCancel: (sessionId: string) => Promise<void>;
  user?: User | null;
  onNavigateToStarter?: () => void;
  onOpenHelpCenter?: () => void;
}

export function Home({ bakingSessions, starters, onSessionCancel, user, onNavigateToStarter, onOpenHelpCenter }: HomeProps) {
  const favoriteStarter = starters.find(starter => starter.isFavorite);
  const sortedSessions = [...bakingSessions].sort(
    (a, b) => new Date(a.targetBakeTime).getTime() - new Date(b.targetBakeTime).getTime()
  );
  const displayName = user?.displayName || user?.email?.split('@')[0] || 'Baker';

  return (
    <div className="max-w-[1400px] mx-auto space-y-6">
      {/* Welcome text */}
      <div className="mb-8 mt-4">
        <h2 className="text-3xl text-white font-brand font-light italic">
          Hello <span>{displayName},</span>
        </h2>
        <p className="text-sm text-white mt-1">
          Welcome to your dashboard! Track your starters, schedule bakes, and perfect your craft.
        </p>
      </div>

      {/* Main content stack */}
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row gap-6">
          {/* Active Starter - 2/3 of the screen */}
          <div className="sm:w-2/3">
            <ActiveStarter
              starter={favoriteStarter}
              onNavigateToStarter={onNavigateToStarter}
            />
          </div>
          {/* Active Bakes - 1/3 of the screen */}
          <div className="sm:w-1/3">
            <ActiveBakes sessions={sortedSessions} onSessionCancel={onSessionCancel} />
          </div>
        </div>
        {/* Recent Results */}
        <div>
          <RecentResults />
        </div>
      </div>
      
      {/* Footer */}
      <div>
        <p className="text-center text-sm text-gray-600 mt-1">
            Need help using Breadlify? {" "}
            <button
                onClick={onOpenHelpCenter}
                className="text-blue-500 hover:underline cursor-pointer inline-flex items-center gap-1"
            >
                Visit our user help center
                <LifeBuoy className="w-4 h-4 stroke-red-500" />
            </button>
        </p>
        <p className="text-center text-sm text-gray-600">
            © Breadlify 2025 - All rights reserved.
        </p>
      </div>
    </div>
  );
}